const paginationBatchSizeOptions = [
  { value: 1, label: '1 Record' },
  { value: 5, label: '5 Records' },
  { value: 10, label: '10 Records' },
  { value: 25, label: '25 Records' },
  { value: 50, label: '50 Records' },
  { value: 100, label: '100 Records' },
  { value: 250, label: '250 Records' },
  { value: 500, label: '500 Records' },
  { value: 1000, label: '1,000 Records' },
  { value: 2500, label: '2,500 Records' },
  { value: 5000, label: '5,000 Records' },
  { value: 10000, label: '10,000 Records' }
];

export default paginationBatchSizeOptions;
